import React from 'react';
import button from "bootstrap/js/src/button";

const Button = (props) => {
    const {
        label       = '',
        onClick     = () => {},
        disabled    = false,
        inverse     = false,
        style       = {},
        type        = 'normal',
    } = props;

    const getClasses = () => {
        let classes = 'button';
        if (inverse) {
            classes += ' inverse';
        }

        switch (type) {
            case 'danger':
                classes += ' danger';
                break;
        }

        return classes;
    }

    return (
        <button onClick={() => onClick()}
                disabled={disabled}
                className={getClasses()}
                style={style}
        >
            <span>{label}</span>
        </button>
    )
}

export default Button;
